import React from 'react';

import { Input, type InputProps } from '@/components/ui/input';
import { cn } from '@/lib/utils';

export const DetailsInput: React.FC<InputProps> = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, className, ...inputProps }, ref) => {
    return (
      <div className={cn('mb-[5px] grid grid-cols-2 gap-2', className)}>
        <p className="min-w-[20%] grow-0 text-base text-text-secondary">{label}:</p>
        <Input ref={ref} {...inputProps} size="xs" className="!w-full" wrapperClassName="w-4/5" />
      </div>
    );
  }
);
